import { applyMiddleware, compose, createStore } from 'redux'
import { thunk } from 'redux-thunk'
import { rafScheduler } from '../middleware/rafScheduler'
import { wsMiddleware } from '../middleware/ws'
import rootReducer from './reducers'

// Support Redux DevTools if present without adding a suppression
const composeEnhancers =
  (typeof window !== 'undefined' && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose

export const createAppStore = () =>
  createStore(rootReducer, composeEnhancers(applyMiddleware(rafScheduler, thunk, wsMiddleware)))

export const store = createAppStore()

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
